import { Injectable, inject } from '@angular/core';
import { CaseAuthorizationState } from '../../states/case-authorization.state';
import { InvestigationAuthorizationState } from '../../states/investigation-authorization.state';

/**
 * Use case for clearing authorization state.
 * Clears both case and investigation authorization data from state.
 * Should be called on logout or when authorization data needs to be reset.
 */
@Injectable({ providedIn: 'root' })
export class ClearAuthorizationUseCase {
  private readonly caseAuthState = inject(CaseAuthorizationState);
  private readonly investigationAuthState = inject(InvestigationAuthorizationState);

  /**
   * Clears all authorization state (case and investigation).
   * This removes cached roles and permissions from both states.
   */
  public execute(): void {
    this.caseAuthState.clear();
    this.investigationAuthState.clear();
  }
}
